"use client";

import { HallowABFlag } from "@packages/ab";
import type { MixpanelLogicFlag } from "@packages/ab/src/providers/ABProvider";

export const FLAGS: { [key in HallowABFlag]?: MixpanelLogicFlag } = {
  [HallowABFlag.WebDOBCollection]: {
    type: "guest",
    evaluate: () => true,
  },
  [HallowABFlag.WebMissionSupporter]: {
    type: "user",
    evaluate: () => true,
  },
  [HallowABFlag.WebRoutines]: {
    type: "user",
    evaluate: () => true,
    kind: "feature",
  },
  [HallowABFlag.WebNotifications]: {
    type: "user",
    evaluate: () => true,
    kind: "feature",
  },
  [HallowABFlag.WebKidsProfileLaunch]: {
    type: "guest",
    evaluate: () => true,
    kind: "feature",
  },
  [HallowABFlag.WebSSHomepage]: {
    type: "guest",
  },
  [HallowABFlag.WebHalfOffFirstYear]: {
    type: "user",
  },
  [HallowABFlag.WebPaidTrial]: {
    type: "user",
  },
  // Guest-scoped: the search service accepts unauthenticated requests, so
  // logged-out visitors can be routed to it too.
  [HallowABFlag.WebSearchService]: {
    kind: "feature",
    type: "guest",
  },
};
